import { CheckSquare, GraduationCap, Heart, Users } from "lucide-react";
import useTranslation from "next-translate/useTranslation";
import { HomeMetricCardV2 as DashboardCard } from "components/ui/v2";

interface IKPIGoalsProps {
  loading?: boolean;
  activePeople: number;
  teams: number;
  roles: number;
  groowcityAdherence: number;
}

const KPIPeopleAndTeams = (props: IKPIGoalsProps) => {
  const { t } = useTranslation("common");
  const { activePeople, teams, roles, groowcityAdherence, loading } = props;

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
      <DashboardCard
        icon={<CheckSquare className="inline h-3.5 w-3.5 text-emerald-400" />}
        title={t("Personas activas en groowcity")}
        value={activePeople}
        filled
        loading={loading}
      />
      <DashboardCard
        icon={<Users className="inline h-3.5 w-3.5 text-indigo-500" />}
        title={t("Equipos")}
        value={teams}
        filled
        loading={loading}
      />
      <DashboardCard
        icon={<GraduationCap className="inline h-3.5 w-3.5 text-cyan-400" />}
        title={t("Roles")}
        value={roles}
        filled
        loading={loading}
      />
      <DashboardCard
        icon={<Heart className="inline h-3.5 w-3.5 text-pink-400" />}
        title={t("Adherencia a Groowcity")}
        value={groowcityAdherence}
        filled
        loading={loading}
      />
    </div>
  );
};

export default KPIPeopleAndTeams;
